import { Routes, Route } from "react-router-dom"
import { AuthProvider } from "@/contexts/AuthContext"
import { ChatHistoryProvider } from "@/contexts/ChatHistoryContext"
import { AnalyticsPageView } from "@/components/AnalyticsPageView"
import { ProtectedRoute } from "@/components/ProtectedRoute"
import { RedirectToApp } from "@/components/RedirectToApp"
import { Chat } from "@/pages/chat"
import { Login } from "@/pages/login"
import { Register } from "@/pages/register"
import { ForgotPassword } from "@/pages/forgot-password"
import { ResetPassword } from "@/pages/reset-password"
import { ChangePassword } from "@/pages/change-password"
import { VerifyEmail } from "@/pages/verify-email"
import { AcceptInvite } from "@/pages/accept-invite"

// Start MSW only when explicitly opted in (VITE_ENABLE_MSW=true). Otherwise a
// `vite dev` run talks to the real backends (VITE_API_URL / VITE_RAG_API_URL).
if (import.meta.env.DEV && import.meta.env.VITE_ENABLE_MSW === 'true') {
  const { worker } = await import('./mocks/browser')
  await worker.start({
    onUnhandledRequest: 'bypass', // Don't warn about unhandled requests
  })
}

function App() {
  return (
    <AuthProvider>
      <AnalyticsPageView />
      <Routes>
        <Route path="/" element={<RedirectToApp />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/accept-invite" element={<AcceptInvite />} />
        <Route
          path="/change-password"
          element={
            <ProtectedRoute>
              <ChangePassword />
            </ProtectedRoute>
          }
        />
        <Route
          path="/chat"
          element={
            <ProtectedRoute>
              <ChatHistoryProvider>
                <Chat />
              </ChatHistoryProvider>
            </ProtectedRoute>
          }
        />
      </Routes>
    </AuthProvider>
  )
}

export default App
